var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frist-set-pwd"},[_c('i',{staticClass:"iconfont iconcuowu"}),_c('h2',[_vm._v("未重新设置密码")]),_c('p',[_vm._v("为了您的账户安全，首次登录需要重新设置密码")]),_c('a',{on:{"click":_vm.toSetPwd}},[_vm._v("去设置")])])
}
var staticRenderFns = []

export { render, staticRenderFns }